<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
  font-size: 14px !important;
  text-align: right;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.legend-con {
  font-family: "Prompt", sans-serif !important;
  display: inline-block;

  ul {
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    span {
      display: inline-block;
    }

    span.chart-legend {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
</style>

<template>
  <v-container fluid>
    <div
      class="text-h4 font-weight-black primary--text text-spacing"
      color="blue"
    >
      รายงานใบกำกับภาษี / ใบเสร็จรับเงิน
    </div>
    <v-divider class="my-2"></v-divider>
    <v-row class="my-n2">
      <v-col cols="12" lg="10" class="mr-n15">
        <date-picker
          :format="momentFormat"
          v-model="time3"
          range
          class="custom-datepicker mr-5"
        ></date-picker>
        <v-select
          label="ภาษีมูลค่าเพิ่ม"
          :items="['เสียภาษี', 'ไม่เสียภาษี']"
          class="mr-5"
          style="width: 180px; display: inline-block"
          v-model="isvat"
          solo
        ></v-select>
        <v-btn large color="info" style="width: 80px" @click="search()">
          <v-icon left dark>mdi-magnify</v-icon>ค้นหา
        </v-btn>
        <v-btn
          class="mx-2"
          large
          color="default"
          style="width: 80px"
          @click="clear()"
        >
          <v-icon left dark> mdi-close </v-icon>ล้าง
        </v-btn>
      </v-col>
      <v-col cols="12" lg="2" class="text-right">
        <v-btn large color="default" @click="export_bill()">
          <v-icon left dark> mdi-printer </v-icon>ดาวน์โหลด Excel
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="getIndex"
      item-key="index"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.index }}</td>
          <td>{{ item.INVOICE_ID }}</td>
          <td>{{ item.CUSTOMER_NAME }}</td>
          <td>{{ item.CREATED_AT | formatDate }}</td>
          <td>{{ item.WEIGHT | delimeter }}</td>
          <td>{{ item.PAID_NO_VAT | delimeter }}</td>
          <td>{{ item.PAID_VAT-item.PAID_NO_VAT | delimeter }}</td>
          <td>{{ item.VAT3 | delimeter }}</td>
          <td>{{ item.TOTAL_PRICE | delimeter }}</td>
        </tr>
      </template>
      <template slot="body.append">
        <tr>
          <th colspan="2" class="text-h5 font-weight-black primary--text">
            จำนวนรวมทั้งหมด
          </th>

          <th></th>
          <th></th>
          <th class="text-h5 font-weight-black primary--text">
            {{ sumField("WEIGHT") | delimeter }}
          </th>
          <th class="text-h5 font-weight-black primary--text">
            {{ sumField("PAID_NO_VAT") | delimeter }}
          </th>
          <th class="text-h5 font-weight-black primary--text">
            {{ sumField("PAID_VAT") | delimeter }}
          </th>
          <th class="text-h5 font-weight-black primary--text">
            {{ sumField("VAT3") | delimeter }}
          </th>
          <th class="text-h5 font-weight-black primary--text">
            {{ sumField("TOTAL_PRICE") | delimeter }}
          </th>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";
import XLSX from "xlsx";
export default {
  components: {},
  name: "InvoiceReport",
  data: () => ({
    time3: [],
    isvat: "เสียภาษี",
    headers: [
      {
        text: "ลำดับ",
        align: "center",
        sortable: true,
        value: "index",
      },
      { text: "รหัสใบกำกับภาษี", value: "INVOICE_ID", align: "center" },
      { text: "ลูกค้า", value: "CUSTOMER_NAME", align: "center" },
      { text: "วันที่", value: "CREATED_AT", align: "center" },
      { text: "จำนวน (กก.)", value: "WEIGHT", align: "left" },
      { text: "จำนวนเงิน", value: "PAID_NO_VAT", align: "left" },
      { text: "ภาษีมูลค่าเพิ่ม", value: "PAID_VAT", align: "left" },
      { text: "ภาษีหัก ณ ที่จ่าย", value: "VAT3", align: "left" },
      { text: "ยอดสุทธิ", value: "TOTAL_PRICE", align: "left" },
    ],
    table_data: [],
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    now_Date: new Date(),
  }),
  watch: {},
  created() {},
  filters: {
    delimeter(data) {
      if (!isNaN(parseFloat(data))) {
        let y = parseFloat(data).toFixed(2);
        let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        return x;
      } else {
        return "";
      }
    },
    formatDate(data) {
      return moment(data).add(543, "year").format("DD-MM-YYYY");
    },
  },
  computed: {
    getIndex() {
      return this.table_data.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
    }),
    sumField(key) {
      return this.table_data.reduce((a, b) => a + (b[key] || 0), 0);
    },
    search() {
      let range_date = this.time3;
      let isvat = this.isvat == "เสียภาษี" ? true : false;
      let search_obj = {
        SE_DATE1: typeof range_date == "undefined" ? null : range_date[0],
        SE_DATE2: typeof range_date == "undefined" ? null : range_date[1],
        ISVAT: isvat,
      };
      this.LOADER(true);
      this.$token_api
        .post(`/report-invoice`, search_obj)
        .then((res) => {
          let data = res.data.data;
          //console.log(data)
          this.table_data = data;
          this.LOADER(false);
        })
        .catch((err) => {
          console.log(err);
          this.LOADER(false);
        });
    },
    clear() {
      this.time3 = [];
      this.isvat = "เสียภาษี";
    },

    export_bill() {
      this.LOADER(true);
      let data = this.getIndex;
      let xls_json = [];
      if (data.length > 0) {
        data.forEach((element) => {
          xls_json.push({
            ลำดับ: element.index,
            รหัสใบกำกับภาษี: element.INVOICE_ID,
            ชื่อลูกค้า: element.CUSTOMER_NAME,
            วันที่: moment(element.CREATED_AT).format("DD-MM-YYYY"),
            "จำนวนน้ำหนัก (กก.)": element.WEIGHT,
            จำนวนเงิน: element.PAID_NO_VAT,
            ภาษีมูลค่าเพิ่ม: element.PAID_VAT,
            "ภาษีหัก ณ ที่จ่าย": element.VAT3,
            ยอดรวมสุทธิ: element.TOTAL_PRICE,
          });
        });

        var wscols = [
          { width: 5 }, // first column
          { width: 20 }, // second column
          { width: 50 }, //...
          { width: 18 },
          { width: 18 },
          { width: 18 },
          { width: 18 },
          { width: 18 },
          { width: 18 },
        ];
        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        dataWS["!cols"] = wscols;
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(
          wb,
          `รายงานใบกำกับภาษี_${moment().format("DD-MM-YYYY")}.xlsx`
        );
        this.LOADER(false);
      } else {
        this.LOADER(false);
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาเลือกเดือนที่มีข้อมูลรายงาน`,
          timer: 1800,
        });
      }
    },
  },

  mounted() {},
};
</script>